module.exports = __webpack_public_path__ + "static/img/nine.0f8f59b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/case/nine.png
// module id = 148j
// module chunks = 34